/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import {
	closeSocialContentModal,
	openSocialContentModal,
	setProductSocialContentState,
	setSocialContentCarouselIndex
} from '../actions';

import { ProductSocialContentState } from '../../model';

/** @format */

export const initialProductSocialContentState: ProductSocialContentState = {
	resultsCount: 0,
	items: [],
	socialCarouselIndex: 0,
	socialModal: false
};

export const productSocialContentReducers = createReducer(
	initialProductSocialContentState,
	on(setProductSocialContentState, (state, { resultsCount, items }) => ({
		...state,
		resultsCount,
		items
	})),
	on(openSocialContentModal, (state) => ({
		...state,
		socialModal: true
	})),
	on(closeSocialContentModal, (state) => ({
		...state,
		socialModal: false
	})),
	on(setSocialContentCarouselIndex, (state, { index }) => ({
		...state,
		socialCarouselIndex: index
	}))
);

export const productSocialContentReducer = (state: ProductSocialContentState, action: Action) =>
	productSocialContentReducers(state, action);
